export enum Context {
  TEST = 'test',
  ACCREDITED_ESTABLISHMENTS = 'accredited_establishments',
  EXPERIMENT = 'experiment',
  FEATURE_FLAG = 'feature_flag',
  SIMULATION_RESULT = 'simulation_result',
  SIMULATOR = 'simulator',
  DATA_CONFIRMATION = 'data_confirmation'
}

export enum TestCode {
  TEST_ERROR = 'test_error'
}

export enum AccreditedEstablishmentsCode {
  GET_ACCREDITED_ESTABLISHMENTS_ERROR = 'get_accredited_establishments_error',
  GET_ACCREDITED_ESTABLISHMENT_MARKERS_ERROR = 'get_accredited_establishment_markers_error',
  GET_ACCREDITED_ESTABLISHMENTS_LIST_ERROR = 'get_accredited_establishments_list_error',
  GET_SPECIALIST_DETAILS_ERROR = 'get_specialist_details_error',
  GET_PROVIDER_DETAILS_ERROR = 'get_provider_details_error',
  GET_ADDRESS_FILTER_OPTIONS_ERROR = 'get_address_filter_options_error',
  GET_PLANS_FILTER_OPTIONS_ERROR = 'get_plans_filter_option_error',
  GET_SPECIALTIES_FILTER_OPTIONS_ERROR = 'get_specialties_filter_options_error',
  GET_SUB_SPECIALTIES_FILTER_OPTIONS_ERROR = 'get_sub_specialties_filter_options_error',
  SEAL_SEARCH_PARAMS_ERROR = 'seal_search_params_error'
}

export enum ExperimentCode {
  GET_EXPERIMENT_VARIANT_ERROR = 'get_experiment_variant_error'
}

export enum FeatureFlagCode {
  GET_FEATURE_FLAG_ERROR = 'get_feature_flag_error'
}

export enum SimulationResultCode {
  GET_SIMULATION_RESULT_ERROR = 'get_simulation_result_error'
}

export enum SimulatorCode {
  ANSWER_SIMULATION_ERROR = 'answer_simulation_error',
  ATTEMPT_ANSWER_SIMULATION_ERROR = 'attempt_answer_simulation_error',
  ATTEMPT_FINISH_SIMULATION_ERROR = 'attempt_finish_simulation_error',
  DEFINE_COMPANY_SIZE_ERROR = 'define_company_size_error',
  FINISH_SIMULATION_ERROR = 'finish_simulation_error',
  INITIALIZE_SIMULATION_ERROR = 'initialize_simulation_error',
  UPSERT_LEAD_ERROR = 'upsert_lead_error',
  CREATE_SIMULATION_ERROR = 'create_simulation_error',
  CREATE_SIMULATION_VALIDATION_ERROR = 'create_simulation_validation_error'
}

export enum DataConfirmationCode {
  GET_CONTACT_UPDATE_ERROR = 'get_contact_update_error',
  SEND_CONTACT_UPDATE_ANSWER_ERROR = 'send_contact_update_answer_error'
}
